function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_1509",
  "data-name": "Rectangle 1509",
  fill: "#fff",
  stroke: "#ef4705",
  strokeWidth: 1,
  strokeDasharray: 10
}, /*#__PURE__*/React.createElement("rect", {
  width: 137,
  height: 97,
  rx: 32,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 136,
  height: 96,
  rx: 31.5,
  fill: "none"
}));

function SvgDaysOffBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_22_1",
    "data-name": "Component 22 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 137,
    height: 97,
    viewBox: "0 0 137 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaysOffBg);
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ29tcG9uZW50XzIyXzEiIGRhdGEtbmFtZT0iQ29tcG9uZW50IDIyIOKAkyAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMzciIGhlaWdodD0iOTciIHZpZXdCb3g9IjAgMCAxMzcgOTciPg0KICA8ZyBpZD0iUmVjdGFuZ2xlXzE1MDkiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE1MDkiIGZpbGw9IiNmZmYiIHN0cm9rZT0iI2VmNDcwNSIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtZGFzaGFycmF5PSIxMCI+DQogICAgPHJlY3Qgd2lkdGg9IjEzNyIgaGVpZ2h0PSI5NyIgcng9IjMyIiBzdHJva2U9Im5vbmUiLz4NCiAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjEzNiIgaGVpZ2h0PSI5NiIgcng9IjMxLjUiIGZpbGw9Im5vbmUiLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { ForwardRef as ReactComponent };